import { useAccountMenuAction } from './actions/useAccountMenuAction'
import { useMainLayoutProps } from './actions/useMainLayoutProps'
import { usePinLimitDialogActions } from './actions/usePinLimitDialogActions'
import { useRenameThreadAction } from './actions/useRenameThreadAction'
import { useThreadMenuAction } from './actions/useThreadMenuAction'
import { useThreadShareActions } from './actions/useThreadShareActions'
import { useAppShellChatSendActions } from './useAppShellChatSendActions'
import { useEffect, useRef } from 'react'
import { useVoiceChat } from '@/features/chat/voice/useVoiceChat'
import { useHomeChatIdStart } from './useHomeChatIdStart'
import { useHomeVoiceStart } from './useHomeVoiceStart'
import { useModelSelectionAction } from './actions/useModelSelectionAction'

/**
 * Thread + send handlers and `mainLayoutProps` bundle.
 * @param {object} m — return value of `useAppShellChatModel`
 */
export function useAppShellChatActions(m) {
  const rename = useRenameThreadAction(m)
  const share = useThreadShareActions(m)
  const pinLimit = usePinLimitDialogActions(m)
  const menu = useThreadMenuAction(m)
  const account = useAccountMenuAction()
  const voiceEventRef = useRef(null)
  const send = useAppShellChatSendActions(m, (event) => voiceEventRef.current?.(event))
  const voice = useVoiceChat({
    conversationId: m.displayThreadId,
    onTranscript: (text) => send.handleSendMessage({ text }),
  })
  useEffect(() => { voiceEventRef.current = voice.publishChatEvent }, [voice.publishChatEvent])
  const startHomeVoice = useHomeVoiceStart({ m, voice })
  const ensureHomeChatId = useHomeChatIdStart({ m })
  const handleModelChange = useModelSelectionAction(m)
  const { mainLayoutProps } = useMainLayoutProps(m, {
    handleSendMessage: send.handleSendMessage,
    ...send.versions,
    handleSendEditVersion: send.handleSendEditVersion,
    handleRegenerateAssistantVersion: send.handleRegenerateAssistantVersion,
    handleMainAskBarPrefill: send.prefill.handleMainAskBarPrefill,
    agentQuestion: send.agentQuestion,
    handleConnectAppSend: send.connect.handleConnectAppSend,
    voice,
    startHomeVoice,
    ensureHomeChatId,
    handleModelChange,
  })
  return { ...rename, ...menu, ...account, ...share, ...pinLimit, mainLayoutProps }
}
